export {default as PersistStorage} from 'redux-persist/lib/storage'; // defaults to localStorage for web
